import React from "react";
import { Link } from "react-router-dom";
import { BrandMark } from "@/components/AppShell";
import { Button } from "@/components/ui/button";
import { ArrowLeft, ShieldCheck, Download, UserX, MailCheck } from "lucide-react";

const RIGHTS = [
  { icon: Download, title: "Right to access", desc: "Download a complete JSON export of your data at any time from Privacy & Data settings." },
  { icon: ShieldCheck, title: "Right to correction", desc: "Edit your profile inline. For fields you cannot self-edit, submit a correction request to the DPO." },
  { icon: UserX, title: "Right to erasure", desc: "Delete your account. Personally-identifiable data is removed within 30 days, subject to statutory retention." },
  { icon: MailCheck, title: "Right to grievance redressal", desc: "File a grievance to our Data Protection Officer. SLA: 30 days." },
];

export default function DPDP() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-white">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
          <Link to="/"><BrandMark /></Link>
          <Link to="/" className="text-sm text-muted-foreground hover:text-primary inline-flex items-center gap-1"><ArrowLeft size={14} /> Home</Link>
        </div>
      </header>

      <section className="max-w-5xl mx-auto px-6 lg:px-10 py-14">
        <div className="overline">Compliance · India DPDP Act, 2023</div>
        <h1 className="mt-3 font-serif text-4xl md:text-5xl text-primary leading-tight max-w-2xl">
          Your data rights, honoured by design.
        </h1>
        <p className="mt-4 text-muted-foreground max-w-2xl">
          Arogya Pramana operates as a <strong>Data Fiduciary</strong> under India&apos;s Digital Personal Data Protection Act, 2023. Every right the law grants you is directly exercisable from your account — no support ticket required.
        </p>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4">
          {RIGHTS.map((r) => (
            <div key={r.title} className="rounded-lg border border-border bg-white p-6" data-testid={`dpdp-right-${r.title.toLowerCase().replace(/\s+/g, "-")}`}>
              <div className="w-10 h-10 rounded-md bg-primary/8 text-primary flex items-center justify-center">
                <r.icon size={18} />
              </div>
              <h3 className="mt-4 font-serif text-2xl text-primary">{r.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-lg border border-border bg-primary text-primary-foreground p-8">
          <div className="overline text-primary-foreground/70">Grievance Officer</div>
          <h2 className="mt-2 font-serif text-3xl">Dr. Ananya Rao</h2>
          <p className="mt-1 text-primary-foreground/80">Data Protection Officer · Arogya Pramana Trust Infrastructure Pvt. Ltd.</p>
          <div className="mt-4 flex flex-wrap gap-3 text-sm">
            <a href="mailto:dpo@arogyapramana.in" className="rounded-md bg-white text-primary px-3 py-2 font-medium hover:bg-white/90 transition-colors" data-testid="dpdp-dpo-email">dpo@arogyapramana.in</a>
            <Link to="/grievance"><Button variant="ghost" className="border border-primary-foreground/40 hover:bg-primary-foreground/10 hover:text-primary-foreground" data-testid="dpdp-file-grievance">File a grievance</Button></Link>
          </div>
        </div>

        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/privacy" className="text-sm text-primary underline">Privacy Policy →</Link>
          <span className="text-muted-foreground">·</span>
          <Link to="/terms" className="text-sm text-primary underline">Terms of Service →</Link>
          <span className="text-muted-foreground">·</span>
          <Link to="/settings/privacy" className="text-sm text-primary underline">Privacy &amp; Data settings →</Link>
        </div>
      </section>
    </div>
  );
}
